"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StarOutlineIcon = require("./StarOutlineIcon");

var _StarOutlineIcon2 = _interopRequireDefault(_StarOutlineIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _StarOutlineIcon2.default;